import { CoreBox } from '@vitvio/design-system';
import type { TurnoverSlot } from '../types';
import { useJobCard } from '../hooks/useJobCard';
import { InfoBox } from './infoBox';

export function TurnoverCard(props: TurnoverSlot) {
  const { data } = props;
  const { shadingHeight, statusColor, shadingColors } = useJobCard(data);

  return (
    <CoreBox fullH bg={statusColor} borderRadius="md" flexColumn relative group>
      <CoreBox
        absolute
        bottom={0}
        fullW
        h={shadingHeight}
        borderRadiusB="md"
        bg={shadingColors?.bg}
        bgStripeColor={shadingColors?.stripe}
      />
      <CoreBox sticky top="0">
        <InfoBox data={data} isTurnover />
      </CoreBox>
    </CoreBox>
  );
}
